

export function IconChoice() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9" fill="white" stroke="black" strokeWidth="2" />
        </svg>

    )
}

export function IconWrong() {
    return (
        <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect width="21.0526" height="20" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M10.5261 0.833344C5.19713 0.833344 0.876953 4.93751 0.876953 10C0.876953 15.0625 5.19713 19.1667 10.5261 19.1667C15.855 19.1667 20.1752 15.0625 20.1752 10C20.1752 4.93751 15.855 0.833344 10.5261 0.833344ZM13.7778 8.08918C13.9376 7.93201 14.026 7.72151 14.024 7.50301C14.022 7.28451 13.9298 7.0755 13.7671 6.921C13.6045 6.76649 13.3845 6.67885 13.1545 6.67695C12.9245 6.67505 12.7029 6.75905 12.5375 6.91084L10.5261 8.82168L8.51467 6.91084C8.43375 6.83125 8.33696 6.76777 8.22994 6.72409C8.12292 6.68042 8.00781 6.65743 7.89134 6.65647C7.77487 6.65551 7.65936 6.67659 7.55155 6.71849C7.44375 6.76039 7.34581 6.82227 7.26345 6.90052C7.18109 6.97876 7.11595 7.0718 7.07185 7.17422C7.02774 7.27663 7.00555 7.38636 7.00656 7.49701C7.00757 7.60766 7.03177 7.71701 7.07774 7.81868C7.12371 7.92035 7.19054 8.0123 7.27432 8.08918L9.28572 10L7.27432 11.9108C7.19054 11.9877 7.12371 12.0797 7.07774 12.1813C7.03177 12.283 7.00757 12.3924 7.00656 12.503C7.00555 12.6137 7.02774 12.7234 7.07185 12.8258C7.11595 12.9282 7.18109 13.0213 7.26345 13.0995C7.34581 13.1778 7.44375 13.2396 7.55155 13.2815C7.65936 13.3234 7.77487 13.3445 7.89134 13.3436C8.00781 13.3426 8.12292 13.3196 8.22994 13.2759C8.33696 13.2323 8.43375 13.1688 8.51467 13.0892L10.5261 11.1783L12.5375 13.0892C12.7029 13.241 12.9245 13.325 13.1545 13.3231C13.3845 13.3212 13.6045 13.2335 13.7671 13.079C13.9298 12.9245 14.022 12.7155 14.024 12.497C14.026 12.2785 13.9376 12.068 13.7778 11.9108L11.7664 10L13.7778 8.08918Z" fill="#FF0000" />
        </svg>

    )
}

export function IconCorrect() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10H0ZM9.42933 14.28L15.1867 7.08267L14.1467 6.25067L9.23733 12.3853L5.76 9.488L4.90667 10.512L9.42933 14.2813V14.28Z" fill="#14FF00" />
        </svg>

    )
}